import { useTranslation } from 'react-i18next';
import {
  HEALTH_GOAL_LABEL_KEYS,
  isKnownHealthGoal,
} from '../common/utils/video-placement-utils';

export function useAudienceLabel(): (goals: string[]) => string {
  const { t } = useTranslation();

  return (goals) =>
    goals.length
      ? goals
          .map((goal) =>
            isKnownHealthGoal(goal) ? t(HEALTH_GOAL_LABEL_KEYS[goal]) : goal
          )
          .join(', ')
      : t('videos.placement.everyone');
}
